import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { CSSProperties, ReactNode } from 'react';

export interface GenericHeaderProps {
  title: string;
  text: string;
  imagePath?: string;
  style?: CSSProperties;
  supportButtons?: ReactNode;
}

export const GenericHeader = ({
  title,
  text,
  imagePath,
  style,
  supportButtons,
}: Readonly<GenericHeaderProps>) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '250px',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          alignSelf: 'flex-end',
        }}
      >
        {supportButtons}
      </Box>
      <Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <Box
            sx={{
              maxWidth: '50%',
            }}
          >
            <Typography
              variant="h1"
              sx={{
                fontFamily: '"MB Corpo A Text Condensed"',
                fontSize: '48px',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '56px',
              }}
            >
              {title}
            </Typography>
            <Box sx={{ marginTop: '16px' }}>
              <Typography
                variant="body1"
                sx={{
                  fontFamily: 'MB Corpo S Text',
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: '400',
                  lineHeight: '24px',
                }}
              >
                {text}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              alignSelf: 'flex-end',
              marginTop: '20px',
              paddingBottom: '1rem',
              marginRight: '45px',
            }}
          >
            <img style={style} src={imagePath} alt={`Header for ${title}`} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
